import { render, staticRenderFns } from "./adverse.vue?vue&type=template&id=6fb9b742"
import script from "./adverse.vue?vue&type=script&lang=js"
export * from "./adverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports